import * as React from 'react'
import { usePrevious } from './usePrevious'

export function onValueChangeEffect<T>(effect: React.EffectCallback, value: T) {
  usePrevious(value)
  React.useEffect(effect, [value])
}
